const parseNumberOrNull = (value) => {
  if (value === "" || value === null || typeof value === "undefined")
    return null;
  const number = Number(value);
  return Number.isFinite(number) ? number : null;
};

const toIsoOrNull = (value) => {
  if (!value) return null;
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date.toISOString();
};

const stripNil = (obj) =>
  Object.fromEntries(
    Object.entries(obj).filter(([, val]) => {
      if (val === undefined || val === null) return false;
      if (typeof val === "string") return val.trim().length > 0;
      return true;
    }),
  );

export const normalizeOnboardPayload = (projectName, payload = {}) => {
  const project = String(projectName || payload.project || "").toLowerCase();
  if (!project) return {};

  if (project === "nxmap") {
    const {
      organizationBoundary,
      baseYear,
      reportingYear,
      ghgReportPurpose,
      threshold,
      baseYearStart,
      baseYearEnd,
      // assurance,
      reportingPeriodStart,
      reportingPeriodEnd,
      reportingStandard,
      materialityAssessment,
      progress,
    } = payload;

    const cleanedMateriality =
      Array.isArray(materialityAssessment) && materialityAssessment.length > 0
        ? materialityAssessment
        : undefined;
    return stripNil({
      organizationBoundary,
      baseYear: parseNumberOrNull(baseYear),
      reportingYear: parseNumberOrNull(reportingYear),
      ghgReportPurpose,
      threshold: parseNumberOrNull(threshold),
      baseYearStart: toIsoOrNull(baseYearStart),
      baseYearEnd: toIsoOrNull(baseYearEnd),
      // assurance,
      reportingPeriodStart: toIsoOrNull(reportingPeriodStart),
      reportingPeriodEnd: toIsoOrNull(reportingPeriodEnd),
      reportingStandard,
      materialityAssessment: cleanedMateriality,
      progress,
    });
  }

  if (project === "nxplan") {
    const {
      organizationBoundary,
      baseYear,
      reportingYear,
      targetYear,
      isSBTi,
      targetReduction,
      targetType,
      regressionModel,
      annualReductionRate,
      targetReductionAbs,
      sbtiTemperature,
      baselineValue,
      scope1Emission,
      scope2Emission,
      scope3Emission,
      progress,
    } = payload;
    return stripNil({
      organizationBoundary,
      baseYear: parseNumberOrNull(baseYear),
      reportingYear: parseNumberOrNull(reportingYear),
      targetYear: parseNumberOrNull(targetYear),
      isSBTi: isSBTi || "",
      sbtiTemperature: parseNumberOrNull(sbtiTemperature),
      targetReduction: parseNumberOrNull(targetReduction),
      targetType: targetType || null,
      regressionModel: regressionModel || null,
      annualReductionRate: parseNumberOrNull(annualReductionRate),
      targetReductionAbs: parseNumberOrNull(targetReductionAbs),
      baselineValue,
      scope1Emission,
      scope2Emission,
      scope3Emission,
      progress,
    });
  }

  return stripNil({ ...payload });
};
